// extracted by mini-css-extract-plugin
module.exports = {"columnText":"RoutesTable_columnText__1PdrQ","inputSearch":"RoutesTable_inputSearch__3My1B"};